/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return */
import {
  assign,
  createMachine,
  ErrorPlatformEvent,
  Interpreter,
} from 'xstate-v4'
import sentryCapture from '~/utility/sentryCapture'
import {
  UserEmail,
  UserPendingEmailConfirmationsRepositoryFetch,
} from './UserPendingEmailConfirmationsRepositoryFetch'

type ChangeEmailEvent =
  | { type: 'ADD'; email: string }
  | { type: 'REMOVE'; email: string }
  | { type: 'UPDATE_EMAIL_TO_ADD'; email: string }
  | { type: 'RESEND_CONFIRMATION_EMAIL'; email: string }

interface ChangeEmailContext {
  emailAdded: string
  emailToAdd: string
  errors: Record<string, string[]>
  pendingEmails: Record<string, UserEmail>
  emailToRemove: string
}

export function returnChangeEmailMachine() {
  return createMachine<ChangeEmailContext, ChangeEmailEvent>({
    /** @xstate-layout N4IgpgJg5mDOIC5QGMAWBDAdjAogW3QEsAbAOkImLAGIBtABgF1FQAHAe1kIBdD3MWIAB6J6AGhABPUQF8ZEtFlwESpAGZhuaQtmoR+YcpgBu7ANaHF2MPiJkNW1DqgIdp5Ol78GjH4I5cXgJIwogAjAAc9KRhAKwAbABM9LH0kfEAnBkA7IkS0gjZmaQ5AMy5sRHxsaURiXIKGNa2qg7aumAATp3snaSsxJ5qvXikVsp26prtLm7sHkE+fiEBPHzBoCIIYRmxJQAs2RG5iYnZ+0n7pfnhp2GkERn0+4nHiaVhL-ENIOM2KmR0MggrBqABVAAKABEAIIAFRwAH0cABZGEASQAMoi4QB5REwqFQ5ZsThrfiCLZhd6kehPfaVTK7WJhbLXKSICKlErZOnZWIvSqVWo-P4tQHA9awUjoCAQciUGiE4lMfxkoKUzmxRKkfYZQ5Xfb0Ur0RJJG4IOoRUilXbxU3HegRY6lUVNCaqIEgmVyhVUajK2hhZgrdXrTUIarxG3xHbJej2o30bIWjKJe7lQ5PBLZfkZN1Kf6TL1Sn3y2UQZx6AxGUwWMbuoueyX8aUVsvOVwmeaedZLVWhwLhkJUs73AVhe3xeKlWdWi0Rfb7HmPUqnW0ZW0RAvNAEyluYNu+itVro9PoDIYjBuF8X773tk-YLvuXveJgkkCrDUj8LPDIxHUpy5rE2SRBcFrnHskQZM6VRVKUNT1PIvyNneJatmWZaQNQQiwNwniGOgajcF0AAUSYAJTUGKe4YYeWEVpAn7fsOmzhKUeqkNUYRpGEk67Lx8QWkkeybrB2aHPa+YobRxYHke8pnr0dADqSQ4Ur+CCgcuTqVFEa6JPszrsgU5w6nGCQ5Dk8TZFkO4ehK3qdHAYCYBAADC-BqIQnQEEEfo0AASjgADKOAAHJQoiHm4hFABi6JBWicLonFyJoliLFhpp7GRlcpDrs8rLJnZRwWmEnHRJugo1Maa5JA5TZOaWLmwG5nneb5-nrKQbUdVW+iYIYcz1nJzbOa57leZgPl+W+mB9VNlbPnMCx9h+alfjlGyhJGETjtOXIHUu4l5By2xGdkDwJHEtSbgk8T7E16EKUt7XTV180Bf17mnt0vT9IM3DDH5N67vJk0fZ1s3dQt70Dat3bre+vhbaxuV7fxUSAbsS6ZJxVwVXGNrvK8ORXKaGTfLJaF0W9Ll4OwxgjYq1AhSiuIAGo4NlGm7Vs5zRrmekbgmyQZBanHcpE5TnB8k4mtkL305NTMs0t6uDTWo2WHTkOtWA6uGIzzOdmtC39iG6nkgLiCZNGsSwayM56oKFrJPcdl6uc-InDOKsG5hpsayH-3nkDV5g+NLXB0bzMm-Hxjm8jlubdb238xGvH8bSJp3ayi6HGEFWxrq9q8YklRnLOk5yChmDsBAcCCDHapZ1pAC0Ox7FalVxJO+wCaZiDd8ZecSRklXJrx-KB6oFBUO3tsRmP119x8LJPcPFVO9GiE5GcEQJIKrq07ee5tE42DLz+eXd4hDzwVXd1D9qwkXYu3JmnZTx0rGlV55kGUp0W+bEsZTzztSVkpRMhVAuCPbYhxuTOjNK8NcTxczbnPhDCaUowGYy2AyZcWQ2SZFSM6Bk5wLSd3tKQGoElVwzltOmIB95SwVgIXbbSudkxSR2LmKSEQLQsm5FcLIFwXh0hqM9HBjl2GYXbIvMAXCIy8muugqIDJUiVXTAuAqFdyhy1iKkNkbD6KKQ7DfQcK8tK8U4qQECsFEibnUbafR39bJZHoP-fiZ9GgXyDgxR8cpICqLscZPYc5Uh6R-imT+1J6GsmpsKFxPjYjmLeu2EB4S8omIAnwooAjfbxGERde01UNz8UrrmeycjmoKIYr9GGc0eqYwxtw1I0Yio6JyMdEuF1+LPAeGTAUxoAH+NQoEvBcdoYzVafDZRuS9omOXD0tIfTagDIKJVWcNpUjiV2McXkNMAm4Njk05a8y4Y-WWs4ZZVIUgAS-kPVkLJDgmIqkaZcB9chHBPlXSZMdGnSmadc76vUck2LvljPU0RpwYO1Iud4ktBnpm5AKWCxkdgzmzJktWCcHmIFSDqUhsDdhOkXDpSC3JqZpFNLULksZGr1NegSjWSzoXgK2CY6qZRyGUqoVLM4tIt7JDgbGWc+LDbG01mbaxNsYVbH1NdT4zxxFGRZNTKWoFHFYIPrA+0VQMmstVjKhOpAoWKu5bcRc3FvEshMY8Tc50dl1G4lUac9jpJDxpnIIAA */
    id: 'changeEmail',
    context: {
      emailAdded: '',
      emailToAdd: '',
      emailToRemove: '',
      errors: {},
      pendingEmails: {},
    },
    initial: 'idle',
    on: {
      UPDATE_EMAIL_TO_ADD: {
        actions: assign({
          emailToAdd: (_, { email }) => email,
        }),
      },
    },
    states: {
      idle: {
        after: { 200: 'fetching' },
      },
      fetching: {
        invoke: {
          src: 'getPendingEmails',
          onDone: {
            actions: assign({
              pendingEmails: (context, event) => {
                return { ...context.pendingEmails, ...event.data }
              },
            }),
            target: '#changeEmail.actions',
          },
          onError: {
            actions: ['logError'],
            target: 'error',
          },
        },
      },
      error: {
        entry: ['logError'],
      },
      actions: {
        type: 'parallel',
        states: {
          // TODO: it is hot-fix - it should be done on BE
          // BE should return email ID while adding an email
          // and we should assign it to context
          // UserEmailsAjaxView - form_valid()
          refetch: {
            initial: 'idle',
            states: {
              idle: {},
              refetching: {
                invoke: {
                  src: 'getPendingEmails',
                  onDone: {
                    actions: assign({
                      pendingEmails: (context, event) => {
                        return { ...context.pendingEmails, ...event.data }
                      },
                    }),
                    target: '#changeEmail.actions',
                  },
                  onError: {
                    actions: ['logError'],
                    target: 'error',
                  },
                },
              },
              error: {
                after: {
                  300: 'refetching',
                },
              },
            },
          },
          add: {
            initial: 'idle',
            states: {
              idle: {
                on: {
                  ADD: [
                    {
                      target: 'adding',
                      cond: ({ emailToAdd, pendingEmails }) => {
                        return !pendingEmails[emailToAdd.toLowerCase()]
                      },
                    },
                    {
                      actions: assign({
                        errors: (_) => ({
                          email: ['This email address has already been added'],
                        }),
                      }),
                    },
                  ],
                },
              },
              adding: {
                invoke: {
                  src: 'addPendingEmail',
                  onDone: {
                    actions: assign({
                      emailAdded: ({ emailToAdd }) => emailToAdd,
                      pendingEmails: ({ emailToAdd, pendingEmails }) => {
                        const email = emailToAdd.toLowerCase()
                        pendingEmails[email] = {
                          id: undefined,
                          email,
                          verified: false,
                        }
                        return pendingEmails
                      },
                    }),
                    target: 'added',
                  },
                  onError: {
                    actions: 'logError',
                    target: 'error',
                  },
                },
              },
              added: {
                entry: assign({
                  emailToAdd: (_) => '',
                }),
                after: {
                  400: '#changeEmail.actions.refetch.refetching',
                },
                exit: assign({
                  emailAdded: (_) => '',
                }),
              },
              error: {
                entry: assign((_, { data }: any) => ({ errors: data })),
                always: 'idle',
              },
            },
          },
          resendConfirmation: {
            initial: 'idle',
            states: {
              idle: {
                on: {
                  RESEND_CONFIRMATION_EMAIL: 'resending',
                },
              },
              resending: {
                invoke: {
                  src: 'resendConfirmationEmail',
                  onDone: {
                    target: 'idle',
                    actions: assign({
                      pendingEmails: ({ pendingEmails }: any, { data }) => {
                        const email = Object.values(pendingEmails).find(
                          (e) => (e as UserEmail).id === data,
                        )
                        const emailAddress: string = (email as UserEmail).email

                        pendingEmails[emailAddress].isConfirmationSent = true

                        return pendingEmails
                      },
                    }),
                  },
                  onError: {
                    actions: 'logError',
                    target: 'error',
                  },
                },
              },
              error: {},
            },
          },
          remove: {
            initial: 'idle',
            states: {
              idle: {
                entry: assign({
                  emailToRemove: (_) => '',
                }),
                on: {
                  REMOVE: {
                    actions: assign({
                      emailToRemove: (_, { email }) => email,
                    }),
                    target: 'removing',
                  },
                },
              },
              removing: {
                invoke: {
                  src: 'removePendingEmail',
                  onDone: {
                    actions: 'removePendingEmail',
                    target: 'idle',
                  },
                  onError: {
                    actions: 'logError',
                    target: 'error',
                  },
                },
              },
              error: {},
            },
          },
        },
      },
    },
  }).withConfig({
    actions: {
      logError: (_, _event: any) => {
        const event: ErrorPlatformEvent = _event

        event.data.name = `changeEmailMachine ${event.type} error`

        sentryCapture(event.data)
      },
      removePendingEmail: assign({
        pendingEmails: ({ emailToRemove, pendingEmails }) => {
          const emails = { ...pendingEmails }
          delete emails[emailToRemove]
          return emails
        },
      }),
    },
    services: {
      addPendingEmail: async ({ emailToAdd }: { emailToAdd: string }) => {
        const repo = new UserPendingEmailConfirmationsRepositoryFetch()
        return await repo.add(emailToAdd)
      },
      getPendingEmails: async () => {
        const repo = new UserPendingEmailConfirmationsRepositoryFetch()
        return await repo.get()
      },
      removePendingEmail: (_, { email }: { email: string }) => {
        const repo = new UserPendingEmailConfirmationsRepositoryFetch()
        return repo.remove(email)
      },
      resendConfirmationEmail: (
        { pendingEmails },
        { email }: { email: string },
      ) => {
        const emailId = pendingEmails[email].id || ''
        const repo = new UserPendingEmailConfirmationsRepositoryFetch()
        return repo.resendConfirmation(emailId)
      },
    },
  })
}

export type ChangeEmailMachineInterpreter = Interpreter<
  ChangeEmailContext,
  any,
  ChangeEmailEvent
>
